import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useWeb3Context } from '../context/Web3Context';
import { supportedChainIds, defaultChainID } from '../constants';
import { chianToName } from '../hooks/globalHelpers';

const NetworkSwitcher = () => {
  const { network, error, switchToSupportedNetwork } = useWeb3Context();

  if (error !== "Network" || !network) {
    return null;
  }

  const currentChainName = chianToName(network.chainId);
  const recommendedChainName = chianToName(defaultChainID);

  return (
    <Alert variant="warning" className="mt-3">
      <div className="d-flex align-items-center justify-content-between">
        <div>
          <h6 className="mb-1">
            <i className="fas fa-exclamation-triangle me-2"></i>
            Unsupported Network
          </h6>
          <p className="mb-0 small">
            You're connected to <strong>{currentChainName}</strong>. 
            Please switch to <strong>{recommendedChainName}</strong> to use the bridge.
          </p>
        </div>
        <div className="ms-3">
          <Button
            variant="warning"
            size="sm"
            onClick={() => switchToSupportedNetwork(defaultChainID)}
            className="me-2"
          >
            <i className="fas fa-exchange-alt me-1"></i>
            Switch to {recommendedChainName}
          </Button>
        </div>
      </div>
      
      <hr className="my-2" />
      
      <div className="small text-muted">
        <strong>Supported networks:</strong>
        <ul className="mb-0 mt-1">
          {supportedChainIds.map(chainId => (
            <li key={chainId}>
              {chianToName(chainId)}
              {chainId === defaultChainID && <span className="text-success"> (Recommended)</span>}
              {chainId !== defaultChainID && (
                <Button
                  variant="link"
                  size="sm"
                  className="p-0 ms-2 text-decoration-none"
                  onClick={() => switchToSupportedNetwork(chainId)}
                >
                  Switch
                </Button>
              )}
            </li>
          ))}
        </ul>
      </div>
    </Alert>
  );
};

export default NetworkSwitcher;